// 列表贷超
import { RouteConfig } from 'vue-router';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { RouterH5Enum } from '../router-names';

/** 贷超主体迁移 Ab  */
export const newLoanMarketAb = {
  experimentId: '202411111759302565',
  defaultVersionId: '202411111759302633',
};

export default (): RouteConfig[] => ([
  {
    path: RouterH5Enum.home,
    meta: {
      newRedirect: NewVersionEnum.LOAN_MARKET,
      newRedirectReplace: true,
      newAb: newLoanMarketAb,
    },
  },
]);
